module.exports = __webpack_public_path__ + "static/media/amex.8434cf88.svg";